export let whiteListIpAddressList = [
  {ip: '216.144.250.150', countryCode: 'us'},
  {ip: '69.162.124.226', countryCode: 'us'},
  {ip: '69.162.124.227', countryCode: 'us'},
  {ip: '69.162.124.228', countryCode: 'us'},
  {ip: '69.162.124.229', countryCode: 'us'},
  {ip: '69.162.124.230', countryCode: 'us'},
  {ip: '69.162.124.231', countryCode: 'us'},
  {ip: '69.162.124.232', countryCode: 'us'},
  {ip: '69.162.124.233', countryCode: 'us'},
  {ip: '69.162.124.234', countryCode: 'us'},
  {ip: '69.162.124.235', countryCode: 'us'},
  {ip: '69.162.124.236', countryCode: 'us'},
  {ip: '69.162.124.237', countryCode: 'us'},
  {ip: '63.143.42.242', countryCode: 'us'},
  {ip: '63.143.42.243', countryCode: 'us'},
  {ip: '63.143.42.244', countryCode: 'us'},
  {ip: '63.143.42.245', countryCode: 'us'},
  {ip: '63.143.42.246', countryCode: 'us'},
  {ip: '63.143.42.247', countryCode: 'us'},
  {ip: '63.143.42.248', countryCode: 'us'},
  {ip: '63.143.42.249', countryCode: 'us'},
  {ip: '63.143.42.250', countryCode: 'us'},
  {ip: '63.143.42.251', countryCode: 'us'},
  {ip: '63.143.42.252', countryCode: 'us'},
  {ip: '63.143.42.253', countryCode: 'us'},
  {ip: '216.245.221.82', countryCode: 'us'},
  {ip: '216.245.221.83', countryCode: 'us'},
  {ip: '216.245.221.84', countryCode: 'us'},
  {ip: '216.245.221.85', countryCode: 'us'},
  {ip: '216.245.221.86', countryCode: 'us'},
  {ip: '216.245.221.87', countryCode: 'us'},
  {ip: '216.245.221.88', countryCode: 'us'},
  {ip: '216.245.221.89', countryCode: 'us'},
  {ip: '216.245.221.90', countryCode: 'us'},
  {ip: '216.245.221.91', countryCode: 'us'},
  {ip: '216.245.221.92', countryCode: 'us'},
  {ip: '216.245.221.93', countryCode: 'us'},
  {ip: '46.137.190.132', countryCode: 'us'},
  {ip: '122.248.234.23', countryCode: 'us'},
  {ip: '188.226.183.141', countryCode: 'us'},
  {ip: '178.62.52.237', countryCode: 'us'},
  {ip: '54.79.28.129', countryCode: 'us'},
  {ip: '54.94.142.218', countryCode: 'us'},
  {ip: '104.131.107.63', countryCode: 'us'},
  {ip: '54.67.10.127', countryCode: 'us'},
  {ip: '54.64.67.106', countryCode: 'us'},
  {ip: '159.203.30.41', countryCode: 'us'},
  {ip: '46.101.250.135', countryCode: 'us'},
  {ip: '18.221.56.27', countryCode: 'us'},
  {ip: '52.60.129.180', countryCode: 'us'},
  {ip: '159.89.8.111', countryCode: 'us'},
  {ip: '146.185.143.14', countryCode: 'us'},
  {ip: '139.59.173.249', countryCode: 'us'},
  {ip: '165.227.83.148', countryCode: 'us'},
  {ip: '128.199.195.156', countryCode: 'us'},
  {ip: '138.197.150.151', countryCode: 'us'},
  {ip: '34.233.66.117', countryCode: 'us'},
  {ip: '35.185.186.169', countryCode: 'us'},
  {ip: '83.171.239.35', countryCode: 'de'},
  {ip: '34.195.146.191', countryCode: 'sg'}];
